module.exports = __webpack_public_path__ + "static/media/tmLogo.b29624a0.png";